<nz-form-item>
  <nz-form-label translate>payment.beneficiaryName.label</nz-form-label>
  <nz-form-control [nzExtra]="nzExtra">
    <input
      nz-input
      nzSize="large"
      type="text"
      (input)="onBeneficiaryNameInput($event)"
      [nzAutocomplete]="beneficiaryAutocomplete"
      [placeholder]="'payment.beneficiaryName.placeholder' | translate: locale.language"
      [formControl]="beneficiaryNameControl"
      [maxlength]="beneficiaryNameMaxLength"
      [minlength]="beneficiaryNameMinLength"
      data-cy="payment-beneficiary-name-input"
    />
  </nz-form-control>
  <nz-autocomplete nzBackfill [nzNoAnimation]="true" #beneficiaryAutocomplete>
    @for (beneficiary of beneficiaries$ | async; track beneficiary.id) {
    <nz-auto-option
      [nzValue]="beneficiary.name"
      data-cy="payment-beneficiary-autocomplete-option"
      [attr.data-account-number]="beneficiary.accountNumber"
      [attr.data-beneficiary-name]="beneficiary.name"
      (selectionChange)="onBeneficiaryAutocompleteSelectionChange($event, beneficiary)"
    >
      <span>{{ beneficiary.name }} {{ beneficiary.accountNumber | iban }}</span>
    </nz-auto-option>
    }
  </nz-autocomplete>
</nz-form-item>
